// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u9-0";